<template lang="pug">
validation-observer(ref="observer", v-slot="{ validate }")
  v-container.the-main-login
    v-row
      v-col.pb-0(cols="12")
        .info-text.text-center.gokleenblue--text(v-if="!isLoginCustomer")
          | {{ mode == MODE.LOGIN ? 'New Member?' : 'Already Registered?' }}
          .text-decoration-underline.signin-btn.pl-1(@click="changeTemplate")
            | {{ mode == MODE.LOGIN ? 'Sign up here' : 'Sign in here' }}
      template(v-if="mode == MODE.FORGOT_PASSWORD")
        v-col.pt-1(cols="12")
          v-card.rounded-0(color="gokleenblue")
            v-row.py-1.px-2(no-gutters)
              v-col(cols="12", md="3")
                .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }") 
                  | Forgot Password
              v-col(cols="12", md="9")
                v-row(no-gutters)
                  v-col.pa-1(cols="12")
                    validation-provider(v-slot="{ errors }", name="email", rules="required|email")
                      v-text-field.info-textfield(
                        v-model="item.email",
                        :error-messages="errors",
                        label="Email",
                        :disabled="isBusy",
                        solo,
                        hide-details="auto",
                        required)
      template(v-if="mode == MODE.LOGIN || mode == MODE.REGISTER")
        v-col.pt-1(cols="12")
          v-card.rounded-0(color="gokleenblue")
            v-row.py-1.px-2(no-gutters)
              v-col(cols="12", md="3")
                .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }") 
                  | Login Detail
              v-col(cols="12", md="9")
                v-row(no-gutters)
                  v-col.pa-1(cols="12", md="6")
                    validation-provider(v-slot="{ errors }", name="email", rules="required|email")
                      v-text-field.info-textfield(
                        v-model="item.email",
                        :error-messages="errors",
                        label="Email",
                        :disabled="isBusy",
                        solo,
                        hide-details="auto",
                        required)
                  v-col.pa-1(cols="12", md="6")
                    validation-provider(v-slot="{ errors }", name="password", rules="required")
                      v-text-field.info-textfield(
                        v-model="item.password",
                        :error-messages="errors",
                        label="Password",
                        :disabled="isBusy",
                        type="password",
                        solo,
                        @keydown.enter="validate().then(submit)",
                        hide-details="auto",
                        required)
      template(v-if="mode == MODE.REGISTER")
        v-col.py-0(cols="12")
          v-card.rounded-0(color="gokleenblue")
            v-row.py-1.px-2(no-gutters)
              v-col(cols="12", md="3")
                .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }") 
                  | Your Contact Info
              v-col(cols="12", md="9")
                v-row.py-1(no-gutters)
                  v-col.pa-1(cols="12", md="6")
                    validation-provider(v-slot="{ errors }", name="first name", rules="required")
                      v-text-field.info-textfield(
                        v-model="item.firstname",
                        :error-messages="errors",
                        label="FIRST NAME",
                        solo,
                        flat,
                        hide-details="auto")
                  v-col.pa-1(cols="12", md="6")
                    validation-provider(v-slot="{ errors }", name="last name", rules="required")
                      v-text-field.info-textfield(
                        v-model="item.lastname",
                        :error-messages="errors",
                        label="LAST NAME",
                        solo,
                        flat,
                        hide-details="auto")
                  v-col.pa-1(cols="12", md="6")
                    validation-provider(v-slot="{ errors }", name="mobile phone", rules="required")
                      v-text-field.info-textfield(
                        v-model="item.contact",
                        :error-messages="errors",
                        label="MOBILE PHONE NO.",
                        solo,
                        flat,
                        hide-details="auto")
                  v-col.pa-1(cols="12", md="6")
                    v-text-field.info-textfield(
                      v-model="item.contact2",
                      label="OTHER PHONE NO.",
                      solo,
                      flat,
                      hide-details="auto")
                  v-col.pa-1(cols="12")
                    v-text-field.info-textfield(
                      v-model="item.companyname",
                      label="COMPANY NAME",
                      solo,
                      flat,
                      hide-details="auto")
        v-col.pt-5(cols="12")
          v-card.rounded-0(color="gokleenblue")
            v-row.px-2(no-gutters)
              v-col(cols="12", md="3")
                .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }")
                  | Property Type
              v-col(cols="12", md="9")
                .py-2.px-1
                  validation-provider(v-slot="{ errors }", name="property type", rules="required")
                    v-autocomplete.info-textfield(
                      v-model="main_address.property_type",
                      :items="property_types",
                      :error-messages="errors",
                      item-text="name",
                      item-value="id",
                      solo,
                      flat,
                      placeholder="Select Property Type",
                      hide-details="auto")
        v-col.pt-5(cols="12")
          v-card.rounded-0(color="gokleenblue")
            v-row.py-1.px-2(no-gutters)
              v-col(cols="12", md="3")
                .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }") 
                  | Main Address
              v-col(cols="12", md="9")
                .py-2.px-1
                  validation-provider(v-slot="{ errors }", name="main address", rules="required")
                    v-textarea.info-textfield(
                      v-model="main_address.address",
                      :error-messages="errors",
                      label="ADDRESS",
                      solo,
                      flat,
                      no-resize,
                      rows="3",
                      persistent-hint,
                      hint="Ex: 577, Jalan Pelita 3, Pelita Commercial Centre, 98000 Miri, Sarawak, Malaysia.")
      v-col(cols="12")
        v-alert.alert-error(v-if="isInvalid", type="error", text)
          | {{ error }}
        v-row(no-gutters, justify="center")
          v-col(cols="12", md="auto")
            v-btn.ma-1(dark, x-large, rounded, color="primary", :block="isMobile", @click="validate().then(submit)")
              | {{ mode == MODE.LOGIN ? 'Login' : (mode == MODE.REGISTER) ? 'Register' : 'Submit' }}
            v-btn.ma-1(v-if="mode == MODE.LOGIN", dark, x-large, rounded, color="error", :block="isMobile", @click="changeForgotTemplate")
              | forgot password
</template>
<script>
import { DEFAULT_CUSTOMER_VALUE } from "@/helpers/public/DefaultValue";
import { WEBURL_PUBLIC } from "@/helpers/Url";
import ValidateMixins from "@/mixins/ValidateMixins.vue";
import axios from "@/plugins/axios";
import { mapGetters, mapActions } from "vuex";
const MODE = {
  LOGIN: 0,
  REGISTER: 1,
  FORGOT_PASSWORD: 2
};
export default {
  name: "TheMainLogin",
  mixins: [ValidateMixins],
  data: () => ({
    mode: MODE.LOGIN,
    item: Object.assign({}, DEFAULT_CUSTOMER_VALUE),
    error: null,
    isInvalid: false,
    isBusy: false,
    property_types: [],
    main_address: {
      property_type: null,
      address: null
    },
    MODE
  }),
  computed: {
    ...mapGetters("setting", ["isLogin", "isCustomer"]),
    isLoginCustomer() {
      return this.isLogin && this.isCustomer;
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("setting", ["initSetting"]),
    initialize() {
      this.getPropertyType();
    },
    getPropertyType() {
      if (this.isBusy) return;
      this.isBusy = true;

      axios
        .get(WEBURL_PUBLIC.getPropertyType)
        .then(res => {
          let data = res.data;

          if (data.property_types && data.property_types.length > 0) {
            this.property_types = data.property_types;
          }
          this.isBusy = false;
        })
        .catch(() => {
          this.isBusy = false;
        });
    },
    submit(isValid) {
      if (isValid) {
        if (this.mode == MODE.LOGIN) return this.save(WEBURL_PUBLIC.submitCustomerLogin);
        else if (this.mode == MODE.REGISTER) return this.save(WEBURL_PUBLIC.submitCustomerRegister);
        else if (this.mode == MODE.FORGOT_PASSWORD) return this.resetPassword(WEBURL_PUBLIC.submitCustomerReset);
      } else this.onErrorFocus("observer");
    },
    updateSetting() {
      this.initSetting()
        .then(() => {
          this.isBusy = false;
          this.$emit("update");
        })
        .catch(() => {
          this.isBusy = false;
        });
    },
    save(url) {
      if (this.isBusy) return;
      this.isBusy = true;
      this.isInvalid = false;

      let param = {
        items: Object.assign({}, this.item)
      };

      if (this.mode == MODE.REGISTER) {
        let address = [];
        address.push({
          id: 0,
          property_type: this.main_address.property_type,
          address: this.main_address.address,
          order: 1
        });
        param.items.address = address;
      }

      axios
        .post(url, param)
        .then(res => {
          if (res.data) {
            let data = JSON.parse(res.data.d);
            if (data) {
              if (data.status) {
                this.$eventHub.$emit("on-show-snackbar", {
                  message: data.message,
                  color: data.status ? "blue" : "error",
                  timeout: -1,
                  position: {
                    top: true
                  }
                });
                return this.updateSetting();
              } else {
                this.error = data.message;
                this.isBusy = false;
                this.isInvalid = true;
                return;
              }
            }
          }
          this.isBusy = false;
        })
        .catch(() => {
          this.isBusy = false;
        });
    },
    resetPassword(url) {
      if (this.isBusy) return;
      this.isBusy = true;
      this.isInvalid = false;

      let param = {
        items: {
          email: this.item.email
        }
      };

      axios
        .post(url, param)
        .then(res => {
          if (res.data) {
            let data = JSON.parse(res.data.d);
            if (data) {
              if (data.status) {
                this.$eventHub.$emit("on-show-snackbar", {
                  message: data.message,
                  color: data.status ? "blue" : "error",
                  timeout: -1,
                  position: {
                    top: true
                  }
                });
                this.isBusy = false;
                return this.changeTemplate();
              } else {
                this.error = data.message;
                this.isBusy = false;
                this.isInvalid = true;
                return;
              }
            }
          }
          this.isBusy = false;
        })
        .catch(() => {
          this.isBusy = false;
        });
    },
    changeForgotTemplate() {
      // reset form before change
      this.error = null;
      this.isInvalid = false;
      this.item = Object.assign({}, this.item, DEFAULT_CUSTOMER_VALUE);
      this.$refs.observer.reset();

      // toggle template
      this.mode = MODE.FORGOT_PASSWORD;
    },
    changeTemplate() {
      // reset form before change
      this.error = null;
      this.isInvalid = false;
      this.item = Object.assign({}, this.item, DEFAULT_CUSTOMER_VALUE);
      this.$refs.observer.reset();

      // toggle template
      this.mode = this.mode == MODE.LOGIN ? MODE.REGISTER : MODE.LOGIN;
    }
  }
};
</script>
<style lang="scss">
.the-main-login {
  .cursor-pointer input {
    cursor: pointer;
  }
  .info-textfield .error--text,
  .info-textfield .v-messages__message {
    color: #f5f5f5 !important;
    caret-color: #ff5252 !important;
  }
  .info-textfield.error--text .v-label,
  .info-textfield.error--text ::placeholder {
    color: #ff5252 !important;
  }
  .alert-error .error--text {
    color: #ff5252 !important;
    caret-color: #ff5252 !important;
  }
  .info-text,
  .info-text label {
    font-size: 14px;
  }
  .signin-btn {
    font-weight: 600;
    display: inline-block;
    cursor: pointer;
  }
  .info-textarea-text {
    font-size: 12px;
    font-weight: 500;
  }
}
</style>
